const DataList = [
	{
		id: 10,
		LittleAboutMe:
			"Jatul is a full stack web developer who is very passionate about his work and has been pursuing this web development journey since starting during covid 2020 and working on new projects.If you dont know, then let me tell you that Jatul has worked with many people, first he took the help of YouTube to increase his knowledge, then he did a web development course from Edureka, after that he started applying for jobs and based on that Join the company whose CEO is Mr. John Behr, who is a famous phycologist, he has his own social media company in America, in which Jatul worked as a backend developer.",
	},
	{
		id: 11,
		AboutTop1:
			"Jatul is a Fullstack developer who is passionate about technology, and learning. A proactive, resourceful, and self-motivated person. His continuousand never-ending learning philosophy drives him to keep up with the latesttechnology trends and continuously expand his knowledge. During this short journey, he worked on different applications.",
	},
	{
		id: 12,
		AboutTop2:
			"Interested in knowing the latest information about technology and works on building projects for people who need. He is proficient on MongoDB Express.js React.js Node.js (MERN stack)As you are seeing, he is have created this website myself with the help of react.js and Library, he is have done some animations in it to make it look good.",
	},
	{
		id: 13,
		card1:
			"Talking about me, I have 500+ connections on LinkedIn and I am very active on social media and learn new things and share a lot of job information for people so that they can also move forward in the IT industry.",
	},
	{
		id: 14,
		card2:
			"With me he is the CEO of LeaderBridge.com & John Behr Group Mr John Behr with me, who had come to meet him and his team in india, he had invited me to the Lalit Hotel in Delhi.",
	},
	{
		id: 15,
		card3:
			"In this photo, I am standing with the famous YouTuber Akshay Saini, who is very famous on YouTube for programming teaching videos, I have learned a lot from him for his Namaste JavaScript course.",
	},
];
export default DataList;
